import React, {Component} from "react";
// import {slugify} from "../../utils/stringSlugify";
import {slugify} from "../../../commonfiles/stringSlugify";

import ParseImgURL from "../../utils/parseImgURL";
import {Link} from "react-router-dom";
import play_icon from "../../assets/images/play_icon.png";
import bannerimage from "../../assets/images/banner_placeholder.jpg";
import downloads_play_icon from "../../assets/images/downloads_play_icon.png";


class TvseriesView extends Component {
    errorimg = (e) => {
        e.target.src = bannerimage;
    };

    render() {
        return (
            <div className="player_coverposter">
                {this.props.episodedata.length > 0 && <Link
                    to={{
                    pathname: `/${this.props.episodesParams.PageName}/detail/${this.props.episodedata[0].generalInfo._id}/${slugify(this.props.episodedata[0].globalServiceName)}/${slugify(this.props.episodedata[0].generalInfo.title)}`
                }}>
                    {/* <div className="play_logo">
                        <img src={play_icon} alt="play_logo" className="img-responsive"/>
                        <div>Watch Episode</div>
                        <div className="movie_details-div">
                            <ul>
                                <li>{this.props.episodedata[0].title}</li>
                              
                            </ul>
                        </div>
                    </div> */}
                    <div className="mnr_detail_page player_watch_epi_btn">
                        <div className="plan_episode_btn" onClick={this.latestEpisode}>
                            <button className="btn watch_epi_btn">
                            <img
                        src={downloads_play_icon}
                        alt=""
                        className="downloads_play_icon"
                      />
                            <p className="epi_title">Watch Episode</p>
                            </button>
                        </div>
                    </div>

                    <img
                        src={process.env.REACT_APP_THUMBOR_IMAGES+ParseImgURL(this.props.episodedata[0].images.values, "mdpi", "coverposter")}
                        alt="player_coverposter"
                        className="img-responsive"
                        onError={e => this.errorimg(e)}/>
                </Link>}

            </div>
        );
    }
}

export default TvseriesView;
